import http from "@services/httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { PagedResultDto } from "@services/dto/pagedResultDto"

import { PinkBookModel } from "@models/pinkBook/pinkBookModel"

class PinkBookService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/PinkBook/GetAll", {
      params,
    })
    return res.data.result
  }
  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/PinkBook/Get", {
      params: { id },
    })
    const { result } = res.data
    return PinkBookModel.assign(result)
  }

  // BATCH
  public async createBatch(body: any) {
    const res = await http.post("api/services/app/PinkBook/Create", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async updateBatch(body: any) {
    const res = await http.put("api/services/app/PinkBook/Update", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async deleteBatch(id: number) {
    const res = await http.delete("api/services/app/PinkBook/DeleteBatch", {
      params: { id },
    })
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async bulkDeleteBatch(id: number[]) {
    const res = await http.post("api/services/app/PinkBook/BulkDeleteBatch", id)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async getBatch(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/PinkBook/Get", {
      params: { Id: id },
    })
    const { result } = res.data
    return result
  }

  public async getAllBatch(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/PinkBook/GetAllBatch", {
      params,
    })
    return res.data.result
  }

  public async getListPinkBookProduct(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/PinkBook/GetAllContractUnit", {
      params,
    })
    return res.data.result
  }

  public async getListPinkBookProductByBatchId(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/PinkBook/GetAllDetail", {
      params,
    })
    return res.data.result
  }

  public async getListPinkBookNotification(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/PinkBook/GetAllContractUnit", {
      params,
    })
    return res.data.result
  }

  public async sendNotification(params: any): Promise<any> {
    const res = await http.post("api/services/app/PinkBook/SendNotification", params)
    notifySuccess(
      LNotification("SUCCESS"),
      L("SEND_NOTIFICATION_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async getNotifyHistory(params: any): Promise<any> {
    const res = await http.get("api/services/app/PinkBook/GetAllNotificationHistory", {
      params,
    })
    return res.data.result
  }

  public async updateStatusPinkBookProduct(params: any): Promise<any> {
    const res = await http.put("api/services/app/PinkBook/UpdateDetailStatus", params)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async getDetailPinkBook(params: any): Promise<any> {
    const res = await http.get("api/services/app/PinkBook/GetDetail", {
      params,
    })
    return res.data.result
  }

  public async updatePinkBookDetail(params: any): Promise<any> {
    const res = await http.put("api/services/app/PinkBook/UpdateDetail", params)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async getListPinkBookStatus(params: any): Promise<any> {
    const res = await http.get("api/services/app/PinkBook/GetListPinkBookStatus", {
      params,
    })
    return res.data.result
  }

  public async createOrUpdatePinkBookStatus(params: any): Promise<any> {
    const res = await http.post("api/services/app/PinkBook/CreateOrUpdatePinkBookStatus", params)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
    
  }

  public async getDetailPinkBookStatus(id: number): Promise<any> {
    const res = await http.get("api/services/app/PinkBook/GetStatus", {
      params: { id },
    })
    return res.data.result
  }

  public async getPinkBookContractDetailSetting(id: number): Promise<any> {
    const res = await http.get("api/services/app/PinkBook/GetPinkBookContractDetailSetting", {
      params: { id },
    })
    return res.data.result
  }

  public async createOrUpdatePinkBookContractDetailSetting(params: any): Promise<any> {
    const res = await http.post("api/services/app/PinkBook/CreateOrUpdatePinkBookContractDetailSetting", params)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async getListPinkBookContractDetailSetting(params?: any): Promise<any> {

    const res = await http.get("api/services/app/PinkBook/GetListPinkBookContractDetailSetting", {
      params,
    })
    return res.data.result
  }
}

export default new PinkBookService()
